<!-- <app-preloader></app-preloader> -->
<!-- <app-header-style-one *ngIf="!(location == '/auth/login' || location == '/auth/register' || location == '/coming-soon' || location == '/auth/email-password' || location == '/auth/reset-password')"></app-header-style-one> -->
<router-outlet></router-outlet>
<!-- <app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon' || location == '/email-password' || location == '/reset-password')"></app-footer>
<simple-notifications></simple-notifications> -->
